export enum FeatureFlags {
  stediClearinghouse = 'stediClearinghouse',
  reportSnapshots = 'reportSnapshots',
  serviceLineLevelBilling = 'serviceLineLevelBilling',
  /** Patient-record-level Claim Info (table, resolver, snapshots, UI). */
  patientRecordClaimInfo = 'patientRecordClaimInfo',
  customForms = 'customForms',
  turnOffTracks = 'turnOffTracks',
  deepgram = 'deepgram',
  memberships = 'memberships',
  aiReceptionist = 'aiReceptionist',
  clinicWidgets = 'clinicWidgets',
  autoSendNewPatientSurveys = 'autoSendNewPatientSurveys',
  reExamAlert = 'reExamAlert',
  supplementSupplySalesReport = 'supplementSupplySalesReport',
  subscriberReferrals = 'subscriberReferrals',
  creditCardInformationRequest = 'creditCardInformationRequest',
}

export enum FlagGroups {
  everyone = 'everyone',
  beta = 'beta',
  alpha = 'alpha',
  internal = 'internal',
}

export const flagGroupsArr = [
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Alpha',
    value: 'alpha',
  },
  {
    label: 'Beta',
    value: 'beta',
  },
  {
    label: 'Everyone',
    value: 'everyone',
  },
];
